import routerOptions0 from "/codebuild/output/src1999057527/src/nuxt-porovnej24/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.1_@types+node@22.13.5_db0@0.2.4_eslint@8.29.0_ioredis@5.5.0_rb3qrunf6lczmixvzwmh26jbby/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}